export default "__VITE_ASSET__Cdx5J4Ux__"